import {Component} from '@angular/core';
import {AuthService} from "../../shared/services/auth.service";
import {FormBuilder, FormGroup} from '@angular/forms';
import appConfig from '../../shared/config/app-config';
import {ActivatedRoute} from "@angular/router";
import { GoogleAnalyticsService } from '../../shared/services/google-analytics.service';
import { LoginValidation } from '../../shared/validations/login.validation';
import { invalidIcon } from '../../utils/images';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})

export class LoginComponent {

  form: FormGroup;
  showPassword: boolean = false;
  loader: boolean = false;
  redirectTo: string | null = null;
  public errorMessage: string = ""
  invalidIcon = invalidIcon

  constructor(private authService: AuthService, private formBuilder: FormBuilder, private googleAnalytics: GoogleAnalyticsService,
    private activatedRoute: ActivatedRoute) {
    this.form = LoginValidation.createLoginForm(this.formBuilder)
  }


  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.redirectTo = params['redirectTo'];
    });
  }

  togglePasswordVisibility(e: Event): void {
    e.preventDefault();
    this.showPassword = !this.showPassword;
  }

  login() {

    this.clearErrorMessage();
    this.form.markAllAsTouched()
    if (this.form.invalid) return

    this.loader = true;
    let {email, password} = this.form.value;

    this.authService.login({ email, password: password.trim() }).subscribe(
      () => this.redirectUser(),
      error => this.handleLoginError(error)
    );
  }

  trackButtonClick(btn_name: any) {
    if (btn_name === 'Login') {
      this.form.markAllAsTouched()
      if (this.form.invalid) return
    }
    this.googleAnalytics.trackButtonClick({'button': btn_name, page: 'login'});
  }

  clearErrorMessage() {
    this.errorMessage = ""
  }

  redirectUser(): void {
    window.location.href = this.redirectTo ?? appConfig.vettimesUrl;
  }

  handleLoginError(error: any): void {
    this.loader = false;
    this.errorMessage = error.error?.errors || 'An unexpected error occurred';
  }
}
